import TranslatesContent from "../../DataStore/Languages/translatesContent";
import { IMAGE_BUCKET_URL } from "../../DataStore/ApiConstant";
import { useState, useEffect } from "react";

const GameTabs = ({ games, getKey = false, slot = false, login }) => {
  const [redirectTab, setRedirectTab] = useState(localStorage.getItem("redirectTab") || null);
  const [activeTab, setActiveTab] = useState(localStorage.getItem("redirectTab") || null);

  useEffect(() => {
    console.log("GameTabs useEffect", login, redirectTab, getKey);
    if (login && redirectTab) {
      getKey && getKey(redirectTab);
      setActiveTab(redirectTab);
      localStorage.removeItem("redirectTab");
    }
  }, [login, redirectTab, getKey]);

  let gamesLength = Object.keys(games).length;
  let colNum = 2;

  if (12 % gamesLength === 0) {
    colNum = 12 / gamesLength;
  }

  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      {games &&
        Object.keys(games).map((gameky, ky) => {
          const gmeId = gameky.trim().replace(/ /g, "");
          return (
            <li
              className={`nav-item col`}
              role="presentation"
              key={gameky}
              onClick={() => {
                if (login) {
                  getKey ? getKey(gameky) : console.log("keyCheck");
                  setActiveTab(gameky);
                } else {
                  setRedirectTab(gameky);
                  localStorage.setItem("redirectTab", gameky);
                  console.log("Please login to access this tab.");
                }
              }}
            >
              <button
                className={"nav-link" + (activeTab === gameky || (!activeTab && ky === 0) ? " active" : "")}
                id={gameky.toUpperCase() + "-tab"}
                data-bs-toggle="tab"
                data-bs-target={"#" + gmeId}
                type="button"
                role="tab"
                aria-controls={gameky.toUpperCase()}
                aria-selected={activeTab === gameky || (!activeTab && ky === 0)}
              >
                {slot ? (
                  gameky.replace("_", "-").toUpperCase()
                ) : (
                  <TranslatesContent contentKey={gameky.replace("_", "-")} />
                )}
              </button>
            </li>
          );
        })}
    </ul>
  );
};

export default GameTabs;
